import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Back from "../../common/assets/images/Back.svg";
import Close from "../../common/assets/images/Close.svg";
import moment from "moment";
import {
  Grid,
  Card,
  CardContent,
  Button,
  DialogTitle,
  Alert,
  AlertTitle,
  Dialog,
  DialogContent,
  useMediaQuery,
  Snackbar,
} from "@mui/material";
import { Box } from "@mui/system";
import { ToastContainer, toast } from "react-toastify";

import { deleteUserDetails } from "../redusers/userThunk";

const DeleteUser = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const user_id =
    props && props.SelectedUser
      ? props.SelectedUser.user_id
      : props.SelectedUser.user_id;

  const closeDialog = (e) => {
    e.preventDefault();
    props.onClose();
  };

  const deleteselrecord = (e) => {
    e.preventDefault();
    dispatch(deleteUserDetails(user_id))
      .unwrap()
      .then((resdata) => {
        //dispatch(getRefDoctorsFromTable(hospital_id));
        //navigate("/ReferralDoctor");
        toast.success("User Deleted Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        //dispatch(setsuccessMessage(resdata.message));
      });
    props.onClose();
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Dialog
        fullWidth="70%"
        maxWidth={props.maxWidth}
        open={props.open}
        onClose={props.onClose}
        className={isMobile ? 'report-dialogMobile' : 'report-dialog'}>
        <DialogTitle
          style={{
            borderBottom: "0.8px solid #f0f1fc",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Link
              to="/"
              className="FIle-left"
              onClick={closeDialog}
              style={{width:isMobile && "10px",marginRight:"10px"}}
            >
              <img
                src={Back}
                className="file-img-left"
                alt=""
                style={{width:isMobile && "10px",marginRight:"10px"}}
              />
            </Link>
            <span style={{fontSize:isMobile && "12px"}}>Delete Conformation</span>
          </div>
          <div>
            <Link to="/" className="FIle-right-extreme" onClick={closeDialog}>
              <img src={Close} alt="" 
              style={{width:isMobile && "10px",marginRight:"10px"}}/>
            </Link>
          </div>
        </DialogTitle>
        <DialogContent style={{padding:"0px 10px"}}>
          <Box>
            <form id="bmrn-form">
              <Card style={{ marginTop: 10 }} variant="none">
                <CardContent style={{padding:"0px 0px"}}>
                  <Grid container>
                    <Grid item xs={12} sm={12}>
                      <Alert severity="error">
                        <AlertTitle>
                          Are you sure you want to delete selected User
                        </AlertTitle>
                      </Alert>
                    </Grid>
                    <div className="formSection">
                      <Grid container>
                        <Grid item xs={12} sm={6} className={isMobile && 'mobileAlign'}>
                          <Button
                            variant="contained"
                            className={isMobile ? 'mobileBack' : 'back'}
                            onClick={closeDialog}
                          >
                            Back
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} className={isMobile && 'mobileAlign'}>
                          <Button
                            variant="contained"
                            className={isMobile ? 'mobilePurple' : 'purple-add'}
                            type="submit"
                            onClick={(e) => deleteselrecord(e, user_id)}
                          >
                            <span>Delete</span>
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </CardContent>
              </Card>
            </form>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
export default DeleteUser;
